import styled from "styled-components";

export const MainLayoutWrapper = styled.div`
  width: 100%;
  display: flex;
  & * {
    font-weight: 400;
  }
`;
export const RightWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const WrapperOutlet = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px;
  background: #181818;
`;
export const SideBarWrapper = styled.div`
  height: 100vh;
  display: flex;
  background-color: #2b2b2b;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  width: auto;
`;
export const Arrow = styled.div`
  position: absolute;
  ${(props) => (props.open === true ? "right: 0px" : "right: -20px")};
  top: clamp(50px, 250px, 50vh);
  cursor: pointer;
  width: 20px;
  height: 60px;
  ${(props) => (props.open === true ? "rotate:180deg" : "rotate:0deg")};
  background: var(--main-color);
  clip-path: polygon(100% 0%, 50% 50%, 0% 0%, 0% 100%);
  &:hover {
    width: 25px;
    ${(props) => (props.open === true ? "right: 0px" : "right: -25px")};
    background: white;
  }
`;
